






































import { Component, Prop, Vue } from 'vue-property-decorator'
import { BForm, BFormGroup, BFormInput, BFormCheckbox, BContainer, BRow, BCol, BFormTextarea, BFormInvalidFeedback, BOverlay } from 'bootstrap-vue'
import Configuration from '@/types/Configuration'
import Validator, { handleValidationErrors } from '@/types/Validator'
import EntityReference from '@/types/EntityReference';
import SpinnerButton from '@/components/SpinnerButton.vue';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'b-overlay': BOverlay,
        'b-container': BContainer,
        'b-row': BRow,
        'b-col': BCol,
        'b-form': BForm,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-invalid-feedback': BFormInvalidFeedback,
        'b-form-textarea': BFormTextarea,
        'b-form-checkbox': BFormCheckbox,
        'spinner-btn': SpinnerButton
    }
})
export default class ClientDetails extends Vue {
    @Prop() clientId!: string

    isBusy = true;
    isBusySave = false;
    isBusyDelete = false;
    client: ClientData = {
        id: '',
        sequenceId: 0,
        name: '',
        isActive: true,
        projects: [],
        contactPerson: '',
        identifier: '',
        description: ''
    }
    nameValidator: Validator = {
        isValid: null,
        errors: []
    }

    mounted() {
        this.loadClient(this.clientId);
    }

    clearValidators() {
        this.nameValidator = {
            isValid: null,
            errors: []
        }
    }

    async loadClient(clientId: string) {
        if (clientId.length == 0) {
            this.isBusy = false;
            return;
        }

        this.isBusy = true;

        try {
            const response = await AxiosService.request<ClientData>({
                url: `clientsadministration/${this.clientId}`,
                method: 'GET'
            });

            this.client = response.data;
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    async onSubmit(e: Event) { // eslint-disable-line @typescript-eslint/no-unused-vars
        this.isBusy = true;
        this.isBusySave = true;

        this.clearValidators();

        try {
            await AxiosService.request<boolean>({
                url: `clientsadministration`,
                method: 'POST',
                data: this.client
            });

            this.$root.$bvToast.toast(this.$t('toaster.clientSaved') as string, {
                title: this.$t('toaster.saveClientTitle') as string,
                autoHideDelay: Configuration.ToasterAutoHideDelay,
                appendToast: true,
                variant: Configuration.ToasterVariantSuccess,
                toaster: Configuration.ToasterPosition
            });
            this.$emit('client-saved', true);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    case 400:
                        handleValidationErrors(this, error.response.data.errors.Name, this.nameValidator);
                        return;
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusySave = false;
            this.isBusy = false;
        }
    }

    deleteClient() {
        if (this.client.projects.length != 0) {
            this.$bvModal.msgBoxOk(
                this.$t('modal.deniedClientDeleteMessage', { clientName: this.client.name }) as string, {
                    title: this.$t('modal.deniedClientDeleteTitle') as string,
                    centered: true,
                    buttonSize: 'sm',
                    okTitle: this.$t('modal.closeModal') as string
                }
            );
            return;
        }

        this.$bvModal.msgBoxConfirm(
            this.$t('modal.confirmClientDeleteMessage', { clientName: this.client.name }) as string, {
                title: this.$t('modal.confirmClientDeleteTitle') as string,
                centered: true,
                buttonSize: 'sm',
                okTitle: this.$t('modal.confirmOkTitle') as string,
                cancelTitle: this.$t('modal.confirmCancelTitle') as string
            })
            .then(value => {
                if (value) {
                    this.isBusy = true;
                    this.isBusyDelete = true;

                    try {
                        AxiosService.request<boolean>({
                            url: `clientsadministration?id=${this.clientId}`,
                            method: 'DELETE'
                        });

                        this.$root.$bvToast.toast(this.$t('toaster.clientDeleted', { clientName: this.client.name }) as string, {
                            title: this.$t('toaster.deleteClientTitle') as string,
                            autoHideDelay: Configuration.ToasterAutoHideDelay,
                            appendToast: true,
                            variant: Configuration.ToasterVariantSuccess,
                            toaster: Configuration.ToasterPosition
                        });
                        this.$emit('client-deleted', true);
                    }
                    catch (error) {
                        if (error.response) {
                            switch (error.response.status) {
                                case 404:
                                    return this.$router.push(`/${i18n.locale}/notfound`);
                                case 403:
                                    return this.$router.push(`/${i18n.locale}/accessdenied`);
                                default:
                                    return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                            }
                        }
                    }
                    finally {
                        this.isBusyDelete = false;
                        this.isBusy = false;
                    }
                }
            })
            .catch(error => {
                console.error(error);
            });
    }
}

interface ClientData {
    id: string;
    sequenceId: number;
    name: string;
    projects: EntityReference[];
    isActive: boolean;
    contactPerson: string;
    identifier: string;
    description: string;
}
